import { render, staticRenderFns } from "./PreviewCalendar.vue?vue&type=template&id=473b323e"
import script from "./PreviewCalendar.vue?vue&type=script&lang=js"
export * from "./PreviewCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports